import { Helmet } from 'react-helmet';
import { Divider } from 'antd';

import { useUpdateBreadcrumbParam } from '@/contexts/BreadcrumbContextProvider';

import { usePart } from '@/core/domain/operational/Parts/Parts.hooks';

import { PageProps } from '@/types/PageProps';

import { DefaultRouteTabs, SaveButton } from '@/components/_common';
import PartDetailsDescription from '@/components/Operational/Inventory/Parts/PartDetailsDescription';
import { useIntl } from 'react-intl';
import LastPartsPurchasesList from '@/components/Operational/Inventory/Parts/LastPartsPurchasesList';
import { useInventoryPartFormContext } from '../../InventoryPartsProvider';
import PartFooter from '@/components/Operational/Inventory/Parts/PartFooter';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

function LastPurchasesPage({ route }: PageProps) {
  const intl = useIntl();

  const {
    partId,
    disabled,
    handleSubmit,
    isLoading: contextLoading,
  } = useInventoryPartFormContext();

  const { data: part, isLoading } = usePart(Number(partId));

  useUpdateBreadcrumbParam(':partId', part?.name);

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />
      <DefaultRouteTabs
        route={route.parent}
        permissions={route.permissions}
        baseKey={partId}
        basePath={`/app/operational/inventory/parts/${partId}`}
        extra={
          <SaveButton
            block
            disabled={
              disabled || !hasPermissions([Authorities.REGISTER_PART_EDIT])
            }
            onClick={handleSubmit}
            loading={contextLoading}
          >
            {intl.formatMessage({ id: 'commons.entity.save' })}
          </SaveButton>
        }
      >
        <PartDetailsDescription isLoading={isLoading} part={part} />

        <Divider />

        <LastPartsPurchasesList partId={Number(partId)} />

        <PartFooter partId={Number(partId)} disabled={disabled} />
      </DefaultRouteTabs>
    </>
  );
}

export default LastPurchasesPage;
